import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDownIcon } from '../../icons';
import { useMemo } from 'react';
export function YearPicker({ value, onChange }) {
    const yearRange = useMemo(() => {
        const currentYear = new Date().getFullYear();
        const startYear = currentYear - 30;
        const endYear = currentYear + 5;
        const years = [];
        for (let year = startYear; year <= endYear; year++) {
            years.push(year);
        }
        return years;
    }, []);
    return (_jsx("div", { className: "relative", children: _jsxs("div", { className: "flex items-center gap-1", children: [_jsx("select", { value: value, onChange: (e) => {
                        const year = parseInt(e.target.value, 10);
                        onChange(year);
                    }, className: "appearance-none bg-transparent py-1 px-2 text-sm text-gray-700 font-medium cursor-pointer rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-600 pr-6", children: yearRange.map(year => (_jsx("option", { value: year, children: year }, year))) }), _jsx(ChevronDownIcon, { className: "size-3.5 text-gray-500 absolute right-2 pointer-events-none" })] }) }));
}
